module.exports = __webpack_public_path__ + "static/logo-rem-61822a64249b03c69767a9edfa8b05b3.svg";